import { CareItemData, DuoItem } from '../care/care.ruleset';
import { inviteExpiration } from './duo.ruleset';

export function isExpiredInvitation(timestamp: number, now: number) {
  return now - timestamp > inviteExpiration;
}

export function getDuoItemReward(item: DuoItem) {
  const itemData = CareItemData.find(({ id }) => id === item) as {
    reward_gems: number;
  };
  return itemData?.reward_gems;
}
